'use client'
import { FlightSearchPageResponse } from '@/src/types/seoSrpResult'
import dynamic from 'next/dynamic'

const FlightSchedulePageDesktopContainer = dynamic(
    () =>
        import(/* webpackChunkName: "FlightSchedulePageDesktopContainer" */ '@/src/containers/desktop/flightSchedule'),
    {
        ssr: true
    }
)

const FlightSchedulePageMobileContainer = dynamic(
    () => import(/* webpackChunkName: "FlightSchedulePageMobileContainer" */ '@/src/containers/mobile/flightSchedule/'),
    {
        ssr: true
    }
)

interface FlightScheduleRootLoaderProps {
    isMobile: boolean
    srpData: FlightSearchPageResponse
    hostname?: string
}

const FlightScheduleRootLoader = ({
    isMobile,
    domainCountry,
    hostname
}: {
    isMobile: boolean
    domainCountry: string
    hostname?: string
}) => {
    return isMobile ? (
        <FlightSchedulePageMobileContainer />
    ) : (
        <FlightSchedulePageDesktopContainer domainCountry={domainCountry} hostname={hostname} />
    )
}

export default FlightScheduleRootLoader
